import { Divider, Space, Spin, Dropdown, Table, Modal } from "antd"

export {
  Divider, Space, Spin, Dropdown, Table, Modal
}
